<!--
  ~ Copyright 2022. NXGN Management, LLC. All Rights Reserved.
  -->

<div class="row mt-2">
  <fieldset class="col-md-12">
    <div class="float-right">
      <button
        type="button"
        class="btn btn-light mr-1"
        (click)="setEditable(false)"
      >
        <fa-icon [icon]="faTrash"></fa-icon>
        Cancel Changes
      </button>
      <button
        class="btn btn-primary"
        type="submit"
        [disabled]="actionInProgress || formInvalid"
      >
        <span
          *ngIf="actionInProgress"
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        <fa-icon *ngIf="!actionInProgress" [icon]="faEditPencil"></fa-icon>
        {{ buttonName }}
      </button>
    </div>
  </fieldset>
</div>
